// extracted by mini-css-extract-plugin
module.exports = {"patronStack":"ethPatron-module--patronStack--2hr93","patronAmount":"ethPatron-module--patronAmount--2c0y5","placeholder":"ethPatron-module--placeholder--2R4GC"};